import React from 'react';

type Props = {
  isOpen: boolean;
  onToggle: () => void;
  size?: number; // button size in px
};

export default function NavButton({ isOpen, onToggle, size = 32 }: Props) {
  const barHeight = size * 0.05; // very thin (~1.6px for size=32)
  const barWidth = size * 0.5; // half the button width
  const spacing = barHeight; // small space between bars
  const translate = barHeight + spacing; // for X animation

  const lineStyle = `bg-black/80 dark:bg-gray-100 rounded-full transition-transform duration-300 ease-in-out`;

  return (
    <button
      aria-label={isOpen ? 'Close navigation menu' : 'Open navigation menu'}
      aria-controls="menuNav"
      aria-expanded={isOpen}
      title={isOpen ? 'Close navigation menu' : 'Open navigation menu'}
      type="button"
      className="group z-100 flex flex-col items-center justify-center hover:cursor-pointer md:hidden"
      style={{ width: size, height: size }}
      onClick={onToggle}
    >
      {/* Top bar */}
      <div
        className={lineStyle}
        style={{
          width: barWidth,
          height: barHeight,
          margin: spacing / 2,
          transform: isOpen
            ? `translateY(${translate}px) rotate(45deg)`
            : undefined,
        }}
      />
      {/* Middle bar */}
      <div
        className={lineStyle}
        style={{
          width: barWidth,
          height: barHeight,
          margin: spacing / 2,
          opacity: isOpen ? 0 : 1,
        }}
      />
      {/* Bottom bar */}
      <div
        className={lineStyle}
        style={{
          width: barWidth,
          height: barHeight,
          margin: spacing / 2,
          transform: isOpen
            ? `translateY(${-translate}px) rotate(-45deg)`
            : undefined,
        }}
      />
    </button>
  );
}
